import { z } from 'zod';

export const POWER_LEVELS = [1000, 10000, 100000, 1000000, 10000000, 100000000];
export const DEFAULT_POWER_LEVEL = { min: 1000, max: 100000000 };

const validator = z
    .object({
        min: z.number().optional(),
        max: z.number().optional(),
    })
    .optional()
    .default(DEFAULT_POWER_LEVEL);

export const PowerLevel = { validator };
